import {apiService} from '../../helpers/axios'
import {ParamsRequestGetList, ResponseApi} from '../models/_public'

// const BASE_URL_UPLOAD_FILE = process.env.REACT_APP_BASE_URL_UPLOAD_FILE || ''

export function fetchDashboardChannel(params: ParamsRequestGetList): Promise<ResponseApi<any>> {
  return apiService.get('/channels/count', {params})
}
